import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  }
});

export async function ensureSupabaseReady(): Promise<{ ok: boolean; reason?: string }> {
  if (!supabaseUrl || !supabaseKey) {
    return { ok: false, reason: 'missing-config' };
  }
  try {
    const res = await fetch(`${supabaseUrl}/auth/v1/settings`, {
      headers: {
        apikey: supabaseKey,
      },
    });
    if (!res.ok) {
      return { ok: false, reason: `http-${res.status}` };
    }
    return { ok: true };
  } catch {
    return { ok: false, reason: 'network' };
  }
}
